import {IProduct} from 'modules/product-card/models/ProductResponse';
import {useMemo} from 'react';

export const useProductIsPriceRed = (product?: IProduct | null) => {
    return useMemo(() => {
        if (!product) {
            return false;
        }

        const {base, discount, specPrice} = product.price;

        if (specPrice || discount.price < base.price) {
            return true;
        }

        return false;
    }, [product]);
};
